import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../constants/Fonts';
import './GameClaimedStatusButtons.css';

/** Figma 18011:22109 — claimed / complete */
const CLAIMED_FILL = '#00a912';

/** Figma 18011:22111 — unclaimed / pending */
const UNCLAIMED_FILL = 'rgba(130, 42, 255, 0.22)';
const UNCLAIMED_TEXT = '#003';

/**
 * Live claim category pill below video (Figma 18011:22108 strip).
 * Claimed: solid #00a912 + white label.
 * Unclaimed: purple glass rgba(130,42,255,0.22) + #003 label.
 */
const GameClaimedStatusButtons = ({
    text,
    claimed = false,
    backgroundColor,
    color,
    disabled = false,
    onClick,
    variant = 'default',
    style = {},
}) => {
    const isClaimed =
        claimed === true ||
        backgroundColor === CLAIMED_FILL ||
        backgroundColor === '#1DA44F' ||
        backgroundColor === '#00a912';

    const label = (text || '').toUpperCase();
    const labelColor = color || (isClaimed ? '#FFFFFF' : UNCLAIMED_TEXT);

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            aria-pressed={isClaimed}
            data-claimed={isClaimed ? 'true' : 'false'}
            data-variant={variant}
            className={`game-claim-status-btn${isClaimed ? ' game-claim-status-btn--claimed' : ' game-claim-status-btn--unclaimed'}${disabled ? ' game-claim-status-btn--disabled' : ''}`}
            style={style}
        >
            <span
                aria-hidden
                className="game-claim-status-btn__fill"
                style={{ background: isClaimed ? CLAIMED_FILL : UNCLAIMED_FILL }}
            />
            <span aria-hidden className="game-claim-status-btn__inset" />
            <span
                className="game-claim-status-btn__label"
                style={{
                    fontFamily: FONTS.INTER_SEMIBOLD,
                    color: labelColor,
                }}
            >
                {label}
            </span>
        </button>
    );
};

GameClaimedStatusButtons.propTypes = {
    text: PropTypes.string,
    claimed: PropTypes.bool,
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf(['default', 'wide', 'narrow']),
    style: PropTypes.object,
};

export default GameClaimedStatusButtons;
